import { env } from '../../lib/env/env';

export const vgsConfig = {
  VGS_PROXY_URL: env.getString('VGS_PROXY_URL') || 'http://localhost:8081',
};
